(function ($) {

'use strict';

	/**
	 * history handling for contentlist, productlist, downloadlist
	 */
	$.fn.initHistoryHandler = function () {
		if ($(this).length < 1) {
			return;
		}


		var $histObjs = $(this);
		var $installHistoryHandler = null;

		// check if the a is the element itself or a child element
		if ($histObjs.first().is('a')) {
			$installHistoryHandler = $histObjs;
		} else {
			$installHistoryHandler = $histObjs.find('a');
		}

		$installHistoryHandler.off('click')
				.on('click', function () {
					var href = $(this).attr('href');
					var historyState = (history.state || {});
					historyState.activehref = href;
					history.replaceState(historyState, document.title, document.location.href);

					$.ajax({
						type: 'POST',
						cache: true,
						url: '/index.php',
						async: false,
						data: 'cbbtn=1',
						success: function (data) {
						},
						error: function (jqXHR, textStatus, errorThrown) {
							console.log('Error set back button request! ' + textStatus);
						}
					});

					return true;
				});

		if (history.state && history.state.activehref) {
			var $focusElem = null;

			$installHistoryHandler.each(function () {
				if ($(this).attr('href') === history.state.activehref) {
					$focusElem = $(this);
				}
			});

			if ($focusElem !== null) {
				$focusElem.focus();
			}
			//$focusElem.closest($histObjs)[0].scrollIntoView(true);
		}

	};	// jQuery.fn.initHistoryHandler

}(jQuery));